import {
  CloseMdIcon,
  IconButton,
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
  SearchMdIcon,
} from '@crono-one/design-system';
import { ComponentProps } from 'react';
import { cn } from 'utils/style-utils';

export interface SearchInputViewProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  className?: string;
  placeholder?: string;
  variant?: ComponentProps<typeof InputGroup>['variant'];
  dsSize?: ComponentProps<typeof InputGroup>['dsSize'];
  id?: string;
  disabled?: boolean;
}

const SearchInputView = ({
  value,
  onChange,
  onClear,
  className,
  placeholder = 'Search...',
  variant = 'underline',
  dsSize,
  id,
  disabled,
}: SearchInputViewProps) => {
  return (
    <InputGroup
      variant={variant}
      dsSize={dsSize}
      className={cn('w-75', className)}
    >
      <InputGroupInput
        id={id}
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <InputGroupAddon>
        <SearchMdIcon />
      </InputGroupAddon>
      <InputGroupAddon align="inline-end">
        {value && (
          <IconButton
            label="Clear search"
            icon={CloseMdIcon}
            variant="text"
            size="md"
            disabled={disabled}
            onClick={onClear}
          />
        )}
      </InputGroupAddon>
    </InputGroup>
  );
};

export default SearchInputView;
